"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCommonMotorWidgets = void 0;
var AddDriverPolarAnswerWidget_1 = require("./AddDriverPolarAnswerWidget");
var CarHasModificationWidget_1 = require("./CarHasModificationWidget");
var DisplayCarDetailsWidget_1 = require("./DisplayCarDetailsWidget");
var DriverAllocationPopupWidget_1 = require("./DriverAllocationPopupWidget");
var DriversListWidget_1 = require("./DriversListWidget");
var DrivingLicenseCollapseLabelWidget_1 = require("./DrivingLicenseCollapseLabelWidget");
var OvernightPostcodeWidget_1 = require("./OvernightPostcodeWidget");
var PartialDLNInputWithInfoQuestionWidget_1 = require("./PartialDLNInputWithInfoQuestionWidget");
var VehicleModelLookupWidget_1 = require("./VehicleModelLookupWidget");
var VehicleRegistrationNumberTextBoxQuestionWidget_1 = require("./VehicleRegistrationNumberTextBoxQuestionWidget");
var VehicleRegistrationNumberWidget_1 = require("./VehicleRegistrationNumberWidget");
var WhoIsMainDriverWidget_1 = require("./WhoIsMainDriverWidget");
var WhoIsRegisteredKeeperOrLegalOwnerWidget_1 = require("./WhoIsRegisteredKeeperOrLegalOwnerWidget");
var WhoIsRegisteredKeeperWidgetNB_1 = require("./WhoIsRegisteredKeeperWidgetNB");
var ResolveDriversLicenceWidget_1 = require("./ResolveDriversLicenceWidget");
var DocumentPostRequestInfo_1 = require("./DocumentPostRequestInfo");
var addCommonMotorWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "addDriverPolarAnswerWidget",
        component: AddDriverPolarAnswerWidget_1.AddDriverPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carHasModificationWidget",
        component: CarHasModificationWidget_1.CarHasModificationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "displayCarDetails",
        component: DisplayCarDetailsWidget_1.DisplayCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentPostRequestInfo",
        component: DocumentPostRequestInfo_1.DocumentPostRequestInfo
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "driverAllocationPopup",
        component: DriverAllocationPopupWidget_1.DriverAllocationPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "driversListWidget",
        component: DriversListWidget_1.DriversListWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingLicenseCollapseLabelWidget",
        component: DrivingLicenseCollapseLabelWidget_1.DrivingLicenseCollapseLabelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "overnightPostcode",
        component: OvernightPostcodeWidget_1.OvernightPostcodeWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "partialDLNInputWithInfo",
        component: PartialDLNInputWithInfoQuestionWidget_1.PartialDLNInputWithInfoQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleModelLookup",
        component: VehicleModelLookupWidget_1.VehicleModelLookupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vrnTextBox",
        component: VehicleRegistrationNumberTextBoxQuestionWidget_1.VehicleRegistrationNumberTextBoxQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleRegistrationNumber",
        component: VehicleRegistrationNumberWidget_1.VehicleRegistrationNumberWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "whoIsMainDriverWidget",
        component: WhoIsMainDriverWidget_1.WhoIsMainDriverWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "whoIsRegisteredKeeperOrLegalOwner",
        component: WhoIsRegisteredKeeperOrLegalOwnerWidget_1.WhoIsRegisteredKeeperOrLegalOwnerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "whoIsRegisteredKeeperWidgetNB",
        component: WhoIsRegisteredKeeperWidgetNB_1.WhoIsRegisteredKeeperWidgetNB
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "resolveDriversLicence",
        component: ResolveDriversLicenceWidget_1.ResolveDriversLicenceWidget
    });
};
exports.addCommonMotorWidgets = addCommonMotorWidgets;
//# sourceMappingURL=index.js.map